import { component } from "picoapp";
import KeenSlider from "keen-slider";
import { VideoPlayer } from "../../../scripts/global";

export const camilaGallery = component((node: HTMLElement) => {
  const slider = new KeenSlider(node, {
    breakpoints: {
      "(min-width: 750px)": {
        disabled: true,
      },
    },
    slides: {
      perView: 1.2,
      spacing: 20,
      origin: "center",
    },
  });
});

export const camilaGalleryVideo = component((node: HTMLElement) => {
  new VideoPlayer(node);
});
